"use strict";

var _classCallCheck = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/var/www/viidex/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WalletLinkUI = void 0;
var WalletLinkUI = /*#__PURE__*/function () {
  function WalletLinkUI(_) {
    _classCallCheck(this, WalletLinkUI);
  }
  /**
   * We want to disable showing the qr code for in-page walletlink if the dapp hasn't provided a json rpc url
   */
  _createClass(WalletLinkUI, [{
    key: "setConnectDisabled",
    value: function setConnectDisabled(_) {}
  }]);
  return WalletLinkUI;
}();
exports.WalletLinkUI = WalletLinkUI;